import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {ActionBox} from 'shells/action-box/action-box';
import {ErrorIcon} from 'shells/action-box/action-icons';
import {Link} from 'shells/link/link';

type Props = {
    dripSequenceId: string;
};

export function StartTriggerActionBox(props: Props) {
    return (
        <ActionBox
            title='Start trigger'
            subtitle='Your drip sequence is missing a start trigger'
            icon={<ErrorIcon />}
            actionElement={
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    variant='primary'
                    to={`/email-marketing/sms/drip-sequences/${props.dripSequenceId}/details`}
                >
                    Go to drip sequence details
                </Link>
            }
        />
    );
}
